export enum PageTypes {
  notFound,
  filter,
  product,
  section,
  sections,
}

export const PageTypesNames = {
  [PageTypes.section]: "section",
  [PageTypes.filter]: "filter",
  [PageTypes.product]: "product",
  [PageTypes.sections]: "sections",
};
